<template>
    <transition name="fade">
      <div v-if="visible" class="fixed" @click.stop>
        <div class="bg-white popup">
          <div class="popup-scroll">
          <h1 class="title"><label v-if="currentPlan.id_promo == 0">Nuevo plan:</label><label v-if="currentPlan.id_promo !== 0">Editar:</label> {{currentPlan.nombre || "Título del plan" }}</h1>
          <img src="@/assets/images/ic_close.svg" class="close_icon" @click="closePopup()" />
          
          <h3 v-if="currentPlan.id_promo == 0" class="subtitle">Estás creando un plan nuevo, este plan aún no tiene un ID asignado</h3>
          <h3 v-if="currentPlan.id_promo !== 0" class="subtitle">ID del plan: {{ currentPlan.id_promo }}</h3>

          <h3 v-if="currentPlan.id_promo !== 0 && currentPlan.free_codes != null" class="subtitle-codes">Este plan tiene códigos de compra personalizados, actualmente quedan: {{ currentPlan.free_codes }} códigos libres<br/><label class="subtitle-codes-mini">Esta información se actualiza de madrugada, el número de códigos disponibles puede ser menor.</label></h3>
          
          <div v-if="currentPlan.id_promo !== 0 && currentPlan.free_codes != null" class="flex justify-center mb-md">
            <div class="add_button" @click="addCustomPurchaseCodes()">
              Añadir más códigos personalizados
              <img class="action_icon" src="@/assets/images/ic_add.png" />
            </div>
          </div>
          
          <h4>Datos del plan</h4>
          <div class="fields">
            <div class="input-50">
              <label>Título*</label>
              <input
                type="text"
                required
                v-model="currentPlan.nombre"/>
            </div>
            <div class="input-50">
              <label>Título web*</label>
              <input
                type="text"
                required
                v-model="currentPlan.nombre_web"/>
            </div>
          </div>
          <div class="fields">
            <div class="input-50">
              <label>Categoría principal*</label>
              <select v-model="currentPlan.categoria">
                <option value="bienestar">Bienestar</option>
                <option value="deportes">Deportes</option>
                <option value="gastro">Gastro</option>
                <option value="ocio">Ocio</option>
                <option value="viajes">Viajes</option>
                <option value="regalos">Regalos</option>
              </select>
            </div>
            <div class="input-50">
              <label>Subcategoría principal*</label>
              <select v-model="currentPlan.subcategoria_slug">
                <option v-if="currentPlan.categoria == 'bienestar'" value="dentista">Dentista</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="estetica">Estética</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="masajes-fisioterapia">Masajes y fisioterapia</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="medicina">Medicina</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="mindfulness-relax">Mindfulness</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="nutricionista">Nutrición</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="peluqueria">Peluquería</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="psicologia">Psicología</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="spa-balneario">Spas y balnearios</option>
                <option v-if="currentPlan.categoria == 'bienestar'" value="tattoos">Tattoos</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="clases-de-baile">Clases de Baile</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="natacion-aquagym-piscina">Deportes acuáticos</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="deportes-de-equipo">Deportes de equipo</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="fitness-gym">Deportes de gym</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="esqui-raquetas-quad-buggy-deportes-invierno">Deportes de invierno</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="boxeo-taekwondo-lucha">Deportes de lucha</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="barranquismo-parapente-ferratas-montana">Deportes de montaña</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="karts-paratrike-motor">Deportes de motor</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="deportes-de-raqueta">Deportes de raqueta</option>
                <option v-if="currentPlan.categoria == 'deportes'" value="deportes-individuales">Deportes individuales</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="asiatica">Asiática</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="cursos-talleres-catas">Cursos, talleres y catas</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="desayunos-dulces-brunch">Dulces, desayunos y brunch</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="americana">Hamburguesas y bocadillos</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="healthy">Healthy</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="internacional">Internacional</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="mediterranea">Mediterránea</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="italiana">Pizza y pasta</option>
                <option v-if="currentPlan.categoria == 'gastro'" value="vegetariana-y-vegana">Vegetariana y vegana</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="cine-teatro">Cine y teatro</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="conocer-gente">Conocer gente</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="cursos-talleres-pintura-ceramica">Cursos y talleres</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="escape-room-ocio-alternativo">Escape room y ocio alternativo</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="fotografia">Fotografía</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="juegos-rol-mesa-videojuegos">Juegos de mesa y videojuegos</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="museos-exposiciones">Museos y exposiciones</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="nocturno-musica">Música y ocio nocturno</option>
                <option v-if="currentPlan.categoria == 'ocio'" value="practicar-idiomas">Practicar idiomas</option>
                <option v-if="currentPlan.categoria == 'viajes'" value="autocaravana">Autocaravana</option>
                <option v-if="currentPlan.categoria == 'viajes'" value="camper">Camper</option>
                <option v-if="currentPlan.categoria == 'viajes'" value="casas-rurales-hoteles">Casas rurales y hoteles</option>
                <option v-if="currentPlan.categoria == 'viajes'" value="en-grupo">En grupo</option>
                <option v-if="currentPlan.categoria == 'viajes'" value="en-pareja">En pareja</option>
                <option v-if="currentPlan.categoria == 'viajes'" value="excursiones">Excursiones</option>
                <option v-if="currentPlan.categoria == 'viajes'" value="playa-montana">Playa y montaña</option>
                <option v-if="currentPlan.categoria == 'regalos'" value="tarjetas-regalo">Tarjetas de regalo</option>
              </select>
            </div>
          </div>
          <div class="flex justify-between items-center">
            <div class="flex items-center gap-sm">
              <label>Categorías secundarias</label>
            </div>
            <div class="add_button add_button_small" @click="addCategoryClicked()">
              Añadir categorías
              <img class="action_icon_small" src="@/assets/images/ic_add.png" />
            </div>
          </div>
          <div class="secondary_categories mb-lg">
            <div class="input-100" v-for="category in currentPlan.otras_categorias" :key="category.categoria + '-' + category.subcategoria" style="display: flex; justify-content: space-between; align-items: center; padding: 10px; border-bottom: 1px solid var(--very-clear-gray);">
              <div>-&nbsp;<b>{{ getCategoryLabel(category.categoria) }}</b>:&nbsp;&nbsp;&nbsp;{{ getSubcategoryLabel(category.subcategoria) }}</div>
              <div class="flex items-center">
                <img class="campo-pedir-icon" src="@/assets/images/ic_action_delete.png" @click="deleteSecondaryCategory(category)" title="Eliminar categoría secundaria"/>
              </div>
            </div>
          </div>


          <div class="fields">
            <div class="input-50">
              <label>Festividades</label>
              <select v-model="currentPlan.festivos">
                <option value="">Selecciona una festividad</option>
                <option value="san-valero">San Valero</option>
                <option value="san-vicente-martir">San Vicente Mártir</option>
                <option value="san-valentin">San Valentín</option>
                <option value="carnavales">Carnavales</option>
                <option value="cincomarzada">Cincomarzada</option>
                <option value="san-jose">San José</option>
                <option value="semana-santa">Semana Santa</option>
                <option value="san-jorge">San Jorge</option>
                <option value="san-vicente-ferrer">San Vicente Ferrer</option>
                <option value="verano">Verano</option>
                <option value="fiestas-del-pilar">Fiestas del Pilar</option>
                <option value="san-juan">San Juan</option>
                <option value="halloween">Halloween</option>
                <option value="black-friday">Black Friday</option>
                <option value="puente-de-la-constitucion">Puente de la Constitución</option>
                <option value="navidad">Navidad</option>
                <option value="fallas">Fallas</option>
                <option value="dia-de-la-madre">Día de la madre</option>
                <option value="dia-del-padre">Día del padre</option>
              </select>
            </div>
            <div class="input-50">
              <label>Otros</label>
              <select v-model="currentPlan.otros_items">
                <option value="">Selecciona una categoría extra</option>                
                <option value="teambuilding para empresas">Teambuilding para empresas</option>
                <option value="planesconninos">Planes con niños</option>
                <option value="cumpleanos">Cumpleaños</option>
                <option value="losmaspopulares">Los más populares</option>
                <option value="recomendadosparati">Recomendados para ti</option>
                <option value="top10">Top 10</option>

              </select>
            </div>
          </div>
          <div class="fields">
            <div class="input-50">
              <label>Etiqueta*</label>
              <input
                type="text"
                required
                v-model="currentPlan.etiqueta"/>
            </div>
            <div class="input-50">
              <label>Cantidad vendida personalizada</label>
              <input
                type="text"
                required
                v-model="currentPlan.etiqueta_personalizada"/>
            </div>
          </div>
          <div class="fields">
            <div class="input-100">
              <label>Descripción corta</label>
              <input
                type="text"
                required
                v-model="currentPlan.descripcion_corta"/>
            </div>
          </div>
          <div class="fields">
            <div class="input-100">
              <label>Descripción <span @click="toggleHtmlMode" style="cursor: pointer; color: var(--primary-color); font-size: 12px;">(Pincha para ver el HTML)</span></label>
              <QuillEditor 
                v-if="!isHtmlMode"
                :key="currentPlan.id_promo"
                theme="snow"
                v-model:content="currentPlan.descripcion"
                contentType="html"
                :toolbar="toolbarOptions"
                style="height: 300px"
                class="cp-quill-editor" />
              <textarea
                v-if="isHtmlMode"
                v-model="currentPlan.descripcion"
                style="height: 300px"
              ></textarea>

            </div>
          </div>

          <h4>Imágenes</h4>
          <label style="font-weight: normal; margin-bottom: 15px;">La primera imagen será la imagen principal del plan, si quieres cambiar una imagen pincha sobre ella y selecciona la nueva</label>

          <div class="fields">
            <div class="gallery-input-33">
                <img :src="image0Data" class="image-gallery" @click="openImageModal(0)" @dragover.prevent="handleDragOver" @drop="handleDrop0"/>
                <img v-if="image0Data != defaultGalleryPicture" src="@/assets/images/ic_close.svg" class="image-gallery-delete" @click="clearImage(0)" />
            </div>
            <div class="gallery-input-33">
                <img :src="image1Data" class="image-gallery" @click="openImageModal(1)" @dragover.prevent="handleDragOver" @drop="handleDrop1"/>
                <img v-if="image1Data != defaultGalleryPicture" src="@/assets/images/ic_close.svg" class="image-gallery-delete" @click="clearImage(1)" />
            </div>
            <div class="gallery-input-33">
                <img :src="image2Data" class="image-gallery" @click="openImageModal(2)" @dragover.prevent="handleDragOver" @drop="handleDrop2"/>
                <img v-if="image2Data != defaultGalleryPicture" src="@/assets/images/ic_close.svg" class="image-gallery-delete" @click="clearImage(2)" />
            </div>
          </div>
          <div class="fields">
            <div class="gallery-input-33">
                <img :src="image3Data" class="image-gallery" @click="openImageModal(3)" @dragover.prevent="handleDragOver" @drop="handleDrop3"/>
                <img v-if="image3Data != defaultGalleryPicture" src="@/assets/images/ic_close.svg" class="image-gallery-delete" @click="clearImage(3)" />
            </div>
            <div class="gallery-input-33">
                <img :src="image4Data" class="image-gallery" @click="openImageModal(4)" @dragover.prevent="handleDragOver" @drop="handleDrop4"/>
                <img v-if="image4Data != defaultGalleryPicture" src="@/assets/images/ic_close.svg" class="image-gallery-delete" @click="clearImage(4)" />
            </div>
            <div class="gallery-input-33">
                <img :src="image5Data" class="image-gallery" @click="openImageModal(5)" @dragover.prevent="handleDragOver" @drop="handleDrop5"/>
                <img v-if="image5Data != defaultGalleryPicture" src="@/assets/images/ic_close.svg" class="image-gallery-delete" @click="clearImage(5)" />
            </div>
          </div>
          <input ref="imagePicker" type="file" @change="onFileChange" accept="image/*" style="display: none;" />

          <div class="flex justify-between items-center mt-md mb-md">
            <div class="flex items-center gap-sm">
              <h4>Productos</h4>
              <img class="action_icon" 
                  :src="showHiddenProducts ? require('@/assets/images/ic_hide.png') : require('@/assets/images/ic_show.svg')"
                  @click="showHiddenProducts = !showHiddenProducts"
                  title="Mostrar/Ocultar productos ocultos"/>
            </div>
            <div class="add_button" @click="addProductClicked()">
              Añadir producto
              <img class="action_icon" src="@/assets/images/ic_add.png" />
            </div>
          </div>

          <div class="products">
            <div class="input-100" v-for="product in currentPlan.productos.filter(p => !p.oculto || showHiddenProducts)" :key="product.id_producto_promo" style="display: flex; align-items: center; padding: 10px; border-bottom: 1px solid var(--very-clear-gray);">
              <span :style="product.oculto ? 'color: var(--text-color-placeholder); text-decoration: line-through;' : ''">
                - {{ product.titulo }}
                <template v-if="product.fecha">
                  ({{ new Date(product.fecha).toLocaleDateString() }} - {{ product.hora }})
                </template>
                : {{ product.precio }}€ (+{{ currentPlan.gastos_gestion_usuario }}% GGU)
              </span>
              <div class="flex items-center" style="margin-left: 20px;">
                <img class="campo-pedir-icon" src="@/assets/images/ic_action_participants.png" @click="addParticipantsToProduct(product)" title="Añadir participantes"/>
                <img class="campo-pedir-icon" src="@/assets/images/ic_action_edit.png" @click="editProduct(product)" title="Editar"/>
                <img class="campo-pedir-icon" src="@/assets/images/ic_action_clone.png" @click="cloneProduct(product)" title="Clonar"/>
                <img class="campo-pedir-icon" 
                    :src="product.oculto ? require('@/assets/images/ic_show.svg') : require('@/assets/images/ic_hide.png')"
                    @click="deleteProduct(product)"
                    :title="product.oculto ? 'Mostrar' : 'Ocultar'"/>
              </div>
            </div>
          </div>

          <h4>Personalización de los botones</h4>
          <div class="fields">
            <div class="input-25">
              <label>Tipo de botón*</label>
              <select v-model="currentPlan.tipo_boton">
                <option value="url_reserva_datos">Reserva con datos</option>
                <option value="url_reserva_sin_datos">Reserva sin datos</option>
                <option value="registro_datos">Inscripción con datos</option>
                <option value="registro_sin_datos">Inscripción sin datos</option>
                <option value="url">Ir a url</option>
              </select>
            </div>


            <div class="input-25">
              <label>Texto botón</label>
              <input
                type="text"
                required
                v-model="currentPlan.texto_boton"/>
            </div>
            <div class="input-25">
              <label>Enlace botón</label>
              <input
                :disabled="currentPlan.tipo_boton !== 'url'"
                type="text"
                required
                v-model="currentPlan.enlace_boton"/>
            </div>
            <div class="input-25">
              <label>Pedir cita</label>
              <input
                type="text"
                required
                v-model="currentPlan.boton_pospago"/>
            </div>
          </div>

          <div class="flex justify-between items-center mt-md mb-md">
            <h4>Datos a pedir</h4>
            <div class="add_button" @click="addDataClicked()">
              Añadir dato a pedir
              <img class="action_icon" src="@/assets/images/ic_add.png" />
            </div>
          </div>

          <div class="fields">
            <div class="input-100">
              <label>Descripción de los campos a pedir</label>
              <input
                type="text"
                v-model="currentPlan.descripcion_datos"/>
            </div>
          </div>

          <div style="margin-top: 10px; display: flex; align-items: center; justify-content: space-between; padding: 10px; border-bottom: 1px solid var(--very-clear-gray);" class="input-100" v-for="dato in currentPlan.campos_pedir" :key="dato.id_campo">
            <span>- {{ dato.nombre_campo }}</span>
            <div class="flex items-center">
              <img class="campo-pedir-icon" src="@/assets/images/ic_action_edit.png" @click="editCampoPedir(dato)"/>
              <img class="campo-pedir-icon" src="@/assets/images/ic_close.svg" @click="deleteCampoPedir(dato)"/>
            </div>
          </div>

          <h4>Fechas</h4>
          <div class="fields">
            <div class="input-33">
              <label>Plan canjeable hasta</label>
              <input
                type="date"
                required
                class="expiration-date"
                v-model="currentPlan.fecha_validez" />
            </div>
            <div class="input-33">
              <label>Fecha fin</label>
              <input
                type="date"
                required
                class="expiration-date"
                v-model="currentPlan.fecha_fin" />
            </div>
            <div class="input-33">
              <label>Hora fin</label>
              <input
                type="time"
                v-model="currentPlan.hora_fin"/>
            </div>
          </div>

          <h4>Facturación</h4>
          <div class="fields">
            <div class="input-25">
              <label>Email</label>
              <input
                type="text"
                v-model="currentPlan.email_empresa"/>
            </div>
            <div class="input-25">
              <label>GGE</label>
              <input
                type="number"
                v-model="currentPlan.gastos_gestion_empresa"/>
            </div>
            <div class="input-25">
              <label>GGU</label>
              <input
                type="number"
                v-model="currentPlan.gastos_gestion_usuario"/>
            </div>
            <div class="input-25">
              <label>Uso de cupones</label>
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.uso_cupon"> 
                Permite cupones
              </label>
            </div>
          </div>

          <h4>Localización</h4>
          <div class="fields">
            <div class="input-33 input-checkbox">
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.online" @change="onlineChanged" > 
                Online
              </label>
            </div>

            <div class="input-66">
              <label>Dirección</label>
              <input
                :disabled="currentPlan.online"
                type="text"
                v-model="currentPlan.direccion"/>
            </div>
          </div>
          
          <div class="fields">
            <div class="input-33 input-checkbox">
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.mostrar_cualquier_lugar"> 
                Mostrar en cualquier ciudad
              </label>
            </div>

            <div class="input-66">
              <label class="tooltip-container">
                Ciudad
                <span class="tooltip-text">
                  Puedes añadir varias ciudades separadas por coma.<br><br>
                  La primera ciudad que pongas será la ciudad principal del plan, aparecerá en su dirección. El resto serán otras ciudades donde aparecerá el plan.<br><br>
                  <b>Atención</b>: no añadas coma y espacio, sólo coma.
                </span>
              </label>
              <input
                type="text"
                v-model="currentPlan.ciudad"/>
            </div>
          </div>

          <h4>Regalo</h4>
          <div class="fields">
            <div class="input-33 input-checkbox">
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.es_regalo"> 
                Regalable
              </label>
            </div>

            <div class="input-66">
              <label>Texto para el regalo</label>
              <input
                :disabled="!currentPlan.es_regalo"
                type="text"
                v-model="currentPlan.texto_regalo"/>
            </div>
          </div>

          <h4>SEO</h4>
          <div class="fields">
            <div class="input-33">
              <label>Robots</label>
              <input
                type="text"
                required
                v-model="currentPlan.seo_robots"/>
            </div>
            <div class="input-33">
              <label>Canonical</label>
              <input
                type="text"
                required
                v-model="currentPlan.seo_canonical"/>
            </div>
            <div class="input-33">
              <label>Keywords</label>
              <input
                type="text"
                required
                v-model="currentPlan.seo_keywords"/>
            </div>
          </div>
          <div class="fields">
            <div class="input-100">
              <label>Json-LD</label>
              <textarea
                v-model="currentPlan.seo_json_data"
                style="height: 100px">
              </textarea>
            </div>
          </div>

          <h4>Visibilidad</h4>
          <div class="fields">
            <div class="input-33 input-checkbox">
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.destacadisimo"> 
                Destacadísimo
              </label>
            </div>
            <div class="input-33 input-checkbox">
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.fun_plan"> 
                Click and plan original
              </label>
            </div>
            <div class="input-33 input-checkbox">
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.flash"> 
                Oferta flash
              </label>
            </div>
          </div>

          <div class="fields">
            <div class="input-33 input-checkbox">
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.eliminado"> 
                Eliminado
              </label>
            </div>
            <div class="input-33 input-checkbox">
              <label class="checkbox-label">
                <input class="active_checkbox" type="checkbox" name="activo" v-model="currentPlan.envio_correo_confirmacion"> 
                Enviar correo confirmación
              </label>
            </div>
            <div class="input-33">
              <label>Posición del plan</label>
              <input
                type="number"
                v-model="currentPlan.orden"/>
            </div>
          </div>
          <div class="flex justify-end gap-md mt-md" style="margin-top: 50px;">
            <button @click="closePopup()" class="secondary_button" style="width: auto; min-width: 150px;" >Cancelar</button>
            <button @click="saveClicked()" class="main_button" style="width: auto; min-width: 150px;">Guardar</button>
          </div>
          </div>
        </div>
        <CampoPedirPopup 
          :campoPedir="selectedCampoPedir"
          @campoPedirChanged="campoPedirChanged"
          @campoPedirClosed="campoPedirClosed"
          @campoPedirErrorHappened="campoPedirErrorHappened"
          />
        <ProductPopup 
          :product="selectedProduct"
          @productChanged="productChanged"
          @productPopupCancelled="productPopupCancelled"
          @productErrorHappened="productErrorHappened"
          />
        <TwoButtonPopup
          :title="twoButtonTitle"
          :message="twoButtonMessage"
          :acceptButton="twoButtonAcceptButton"
          @acceptCallback="() => twoButtonConfirmed()"
          :cancelButton="twoButtonCancelButton"
          @cancelCallback="() => twoButtonCancelled()"
          />
        <AddUserToProductPopup 
          :product="selectedProductToAddParticipants"
          @userAddedToProduct="userAddedToProduct"
          @userAddedToProductPopupCancelled="userAddedToProductPopupCancelled"
          @userAddedToProductErrorHappened="userAddedToProductErrorHappened"
          />
        <AddPlanCustomCodesPopup
          :planId="addCustomPurchaseCodesPlanId"
          @addCinemaCodesSaved="addCinemaCodesSaved"
          @addCinemaCodesPopupCancelled="addCinemaCodesPopupCancelled"
          @addCinemaCodesErrorHappened="addCinemaCodesErrorHappened"
          />
        <SecondaryCategoryPopup
          :category="selectedSecondaryCategory"
          @categoryChanged="secondaryCategoryChanged"
          @categoryPopupCancelled="secondaryCategoryPopupCancelled"
          @categoryErrorHappened="secondaryCategoryErrorHappened"
          />
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  import { useLoadingStore } from "@/stores/loadingStore";
  import { QuillEditor } from '@vueup/vue-quill'
  import '@vueup/vue-quill/dist/vue-quill.snow.css'
  import defaultGalleryPicture from '@/assets/images/ic_gallery.png';
  import { refreshToken } from "@/services/authService";
  import { useRouter } from 'vue-router';
  import CampoPedirPopup from "@/components/plans/CampoPedirPopup.vue";
  import TwoButtonPopup from "@/components/common/TwoButtonPopup.vue";
  import ProductPopup from './ProductPopup.vue';
  import SecondaryCategoryPopup from './SecondaryCategoryPopup.vue';
  import AddUserToProductPopup from './AddUserToProductPopup.vue';
  import AddPlanCustomCodesPopup from './AddPlanCustomCodesPopup.vue';
  import { getCategoryLabel, getSubcategoryLabel } from '@/utils/helpers';


  const props = defineProps({
    plan: Object,
  });
  
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike','link'],
    [{ header: [1, 2, 3, false] }],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['clean']
  ];

  const emit = defineEmits(['planChanged', 'planDetailsPopupCancelled', 'planDetailsErrorHappened']);

  const visible = ref(false);
  const error = ref(null);
  const currentPlan = ref(null);
  const imagePicker = ref(null)
  const loadingStore = useLoadingStore();
  const router = useRouter();
  const selectedCampoPedir = ref(null);
  const selectedProduct = ref(null);
  const selectedSecondaryCategory = ref(null);
  const selectedProductToAddParticipants = ref(null);
  const showHiddenProducts = ref(false);

  const twoButtonTitle = ref("");
  const twoButtonMessage = ref("");
  const twoButtonAcceptButton = ref("");
  const twoButtonCancelButton = ref("");
  let twoButtonConfirmed = null;
  let twoButtonCancelled = null;
  const addCustomPurchaseCodesPlanId = ref(0)
  const isHtmlMode = ref(false)

  const toggleHtmlMode = () => {
    isHtmlMode.value = !isHtmlMode.value
  }

  watch(() => props.plan, (newVal) => {
    currentPlan.value = newVal;
    if (newVal != null) {
      image0Data.value = newVal.imagenes[0]?.imagen_url ?? defaultGalleryPicture;
      image1Data.value = newVal.imagenes[1]?.imagen_url ?? defaultGalleryPicture;
      image2Data.value = newVal.imagenes[2]?.imagen_url ?? defaultGalleryPicture;
      image3Data.value = newVal.imagenes[3]?.imagen_url ?? defaultGalleryPicture;
      image4Data.value = newVal.imagenes[4]?.imagen_url ?? defaultGalleryPicture;
      image5Data.value = newVal.imagenes[5]?.imagen_url ?? defaultGalleryPicture;
    }
    visible.value = !!newVal;
  });
  
  const closePopup = () => {
    currentPlan.value = null;
    image0Data.value = null;
    image1Data.value = null;
    image2Data.value = null;
    image3Data.value = null;
    image4Data.value = null;
    image5Data.value = null;
    emit('planDetailsPopupCancelled');
  };

  const saveClicked = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    currentPlan.value.imagenes = [];
    var numImage = 0;
    if (image0Data.value !== defaultGalleryPicture) {
      currentPlan.value.imagenes[numImage] = {"id_promocion": currentPlan.value.id_promo, "num_foto": numImage, "nombre": image0Name.value, "imagen_url": image0Data.value };
      numImage++;
    }
    if (image1Data.value !== defaultGalleryPicture) {
      currentPlan.value.imagenes[numImage] = {"id_promocion": currentPlan.value.id_promo, "num_foto": numImage, "nombre": image1Name.value, "imagen_url": image1Data.value };
      numImage++;
    }
    if (image2Data.value !== defaultGalleryPicture) {
      currentPlan.value.imagenes[numImage] = {"id_promocion": currentPlan.value.id_promo, "num_foto": numImage, "nombre": image2Name.value, "imagen_url": image2Data.value };
      numImage++;
    }
    if (image3Data.value !== defaultGalleryPicture) {
      currentPlan.value.imagenes[numImage] = {"id_promocion": currentPlan.value.id_promo, "num_foto": numImage, "nombre": image3Name.value, "imagen_url": image3Data.value };
      numImage++;
    }
    if (image4Data.value !== defaultGalleryPicture) {
      currentPlan.value.imagenes[numImage] = {"id_promocion": currentPlan.value.id_promo, "num_foto": numImage, "nombre": image4Name.value, "imagen_url": image4Data.value };
      numImage++;
    }
    if (image5Data.value !== defaultGalleryPicture) {
      currentPlan.value.imagenes[numImage] = {"id_promocion": currentPlan.value.id_promo, "num_foto": numImage, "nombre": image5Name.value, "imagen_url": image5Data.value };
      numImage++;
    }

    try {
      let response = await savePlanInAPI();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await savePlanInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        emit('planDetailsErrorHappened', 'Se ha producido un error guardando el plan.');
        loadingStore.setLoading(false);
        return;
      }

      const data = await response.json();

      if (data.errors) {
        emit('planDetailsErrorHappened', data.message);
        loadingStore.setLoading(false);
      } else {
        error.value = null;
        loadingStore.setLoading(false);
        emit('planChanged');
    }      
    } catch (exception) {
      emit('planDetailsErrorHappened', exception.message);
    }
  }

  async function savePlanInAPI() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/plans/set_details", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "vgod": process.env.VUE_APP_API_VGOD,
        "cp-token": process.env.VUE_APP_API_CP_TOKEN,
        "Authorization": "Bearer " + localStorage.getItem('token')
      },
      body: JSON.stringify({
        "user_id": localStorage.getItem('user_id'),
        "plan": currentPlan.value
      }),
    });
  
  }

  const image0Data = ref(null);
  const image0Name = ref(null);
  const image1Data = ref(null);
  const image1Name = ref(null);
  const image2Data = ref(null);
  const image2Name = ref(null);
  const image3Data = ref(null);
  const image3Name = ref(null);
  const image4Data = ref(null);
  const image4Name = ref(null);
  const image5Data = ref(null);
  const image5Name = ref(null);

  var numImageSelected = 0;

  function openImageModal(numImage) {
    numImageSelected = numImage
    imagePicker.value.click();
  }

  function clearImage(numImage) {
    switch (numImage) {
      case 0: 
        image0Data.value = defaultGalleryPicture;
        image0Name.value = null;
        break;
      case 1: 
        image1Data.value = defaultGalleryPicture;
        image1Name.value = null;
        break;
      case 2: 
        image2Data.value = defaultGalleryPicture;
        image2Name.value = null;
        break;
      case 3: 
        image3Data.value = defaultGalleryPicture;
        image3Name.value = null;
        break;
      case 4: 
        image4Data.value = defaultGalleryPicture;
        image4Name.value = null;
        break;
      case 5: 
        image5Data.value = defaultGalleryPicture;
        image5Name.value = null;
        break;
    }
  }

  function handleDragOver(event) {
    event.preventDefault();
  }

  function handleDrop0(event) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    numImageSelected = 0;
    if (file) {
      managePicture(file);
    }
  }

  function handleDrop1(event) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    numImageSelected = 1;
    if (file) {
      managePicture(file);
    }
  }

  function handleDrop2(event) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    numImageSelected = 2;
    if (file) {
      managePicture(file);
    }
  }

  function handleDrop3(event) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    numImageSelected = 3;
    if (file) {
      managePicture(file);
    }
  }

  function handleDrop4(event) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    numImageSelected = 4;
    if (file) {
      managePicture(file);
    }
  }

  function handleDrop5(event) {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    numImageSelected = 5;
    if (file) {
      managePicture(file);
    }
  }


  function onFileChange(event) {
    const file = event.target.files[0];
    if (file) {
      managePicture(file);
    } 
  }

  function managePicture(file) {
    if (!file.type.startsWith('image/')) {
      alert("Selecciona un archivo de imagen válido")
      return
    }

    if (file.size <= 1024 * 1024) {
      const reader = new FileReader()
      reader.onload = e => setImage(numImageSelected, file.name, e.target.result)
      reader.readAsDataURL(file)
      return
    }
    
    const reader = new FileReader()
    reader.onload = e => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const MAX_WIDTH = 1024
        const MAX_HEIGHT = 1024
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }

        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob(
          blob => {
            if (blob.size > 1024 * 1024) {
              alert("No se pudo comprimir la imagen por debajo de 1MB")
              return
            }
            const blobReader = new FileReader()
            blobReader.onload = e2 => {
              setImage(numImageSelected, file.name, e2.target.result)
            }
            blobReader.readAsDataURL(blob)
          },
          'image/jpeg',
          0.8 // calidad 80%
        )
      }
      img.src = e.target.result
    }
    reader.readAsDataURL(file)
  }

  function setImage(numImage, imageName, newUrl) {
    switch (numImage) {
      case 0: 
        image0Data.value = newUrl;
        image0Name.value = imageName;
        break;
      case 1: 
        image1Data.value = newUrl;
        image1Name.value = imageName;
        break;
      case 2: 
        image2Data.value = newUrl;
        image2Name.value = imageName;
        break;
      case 3: 
        image3Data.value = newUrl;
        image3Name.value = imageName;
        break;
      case 4: 
        image4Data.value = newUrl;
        image4Name.value = imageName;
        break;
      case 5: 
        image5Data.value = newUrl;
        image5Name.value = imageName;
        break;
    }
  }

  function onlineChanged(event) {
    if (event.target.checked) {
      currentPlan.value.direccion = "";
    }
  }

  function deleteCampoPedir(campoPedir) {
    twoButtonTitle.value = "Eliminar campo a pedir";
    twoButtonMessage.value = "¿Estás seguro de que quieres eliminar el dato '" + campoPedir.nombre_campo + "' del plan?";
    twoButtonAcceptButton.value = "Si, eliminar";
    twoButtonCancelButton.value = "Cancelar";
    twoButtonConfirmed = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
      deleteCampoPedirConfirmed(campoPedir);
    };
    twoButtonCancelled = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
    }
  }
  function deleteCampoPedirConfirmed(campoPedir) {
    currentPlan.value.campos_pedir = currentPlan.value.campos_pedir.filter(
      campo => campo.id_campo !== campoPedir.id_campo
    );
  }

  function editCampoPedir(campoPedir) {
    selectedCampoPedir.value = campoPedir
  }

  const campoPedirChanged = (campoPedir) => {
    const index = currentPlan.value.campos_pedir.findIndex(
      (c) => c.id_campo === campoPedir.id_campo
    );

    if (index !== -1) {
      currentPlan.value.campos_pedir[index].nombre_campo = campoPedir.nombre_campo;
    } else {
      currentPlan.value.campos_pedir.push(campoPedir);
    }
  }

  const productChanged = (product) => {
    const index = currentPlan.value.productos.findIndex(
      (c) => c.id_producto_promo === product.id_producto_promo
    );

    if (index !== -1) {
      currentPlan.value.productos[index] = product;
    } else {
      currentPlan.value.productos.push(product);
    }
  }

  function addDataClicked() {
    selectedCampoPedir.value = {
        "estado": "ACTIVO",
        "id_campo": -Math.floor(Math.random() * 10000) - 1,
        "id_promocion": currentPlan.value.id_promo,
        "nombre_campo": "",
        "orden": currentPlan.value.campos_pedir.length
    }
  }

  const campoPedirClosed = () => {
    selectedCampoPedir.value = null;
  }

  const productPopupCancelled = () => {
    selectedProduct.value = null;
  }

  const userAddedToProduct = (productId, newStock) => {
    const producto = currentPlan.value.productos.find(p => p.id_producto_promo === productId)
    if (producto) {
      producto.stock_actual = newStock;
    }
    selectedProduct.value = null;
  }

  const userAddedToProductPopupCancelled = () => {
    selectedProductToAddParticipants.value = null;
  }

  const campoPedirErrorHappened = (message) => {
      emit('planDetailsErrorHappened', message);
  }

  const productErrorHappened = (message) => {
      emit('planDetailsErrorHappened', message);
  }

  const userAddedToProductErrorHappened = (message) => {
      emit('planDetailsErrorHappened', message);
  }

  const addCinemaCodesSaved = () => {
    addCustomPurchaseCodesPlanId.value = 0;
  }

  const addCinemaCodesPopupCancelled = () => {
    addCustomPurchaseCodesPlanId.value = 0;
  }
  const addCinemaCodesErrorHappened = (message) => {
      emit('planDetailsErrorHappened', message);
  }

  function addCategoryClicked() {
    selectedSecondaryCategory.value = {
      "categoria": "",
      "subcategoria": ""
    };
  }

  function deleteSecondaryCategory(category) {
    currentPlan.value.otras_categorias = currentPlan.value.otras_categorias.filter(c => c.categoria !== category.categoria && c.subcategoria !== category.subcategoria);
  }

  function addProductClicked() {
    selectedProduct.value = {
        "id_producto_promo": -Math.floor(Math.random() * 10000) - 1,
        "id_promo": currentPlan.value.id_promo,
        "titulo": "",
        "precio": 0,
        "total": 0,
        "fecha": "",
        "hora": "",
        "selec_minima": 1,
        "selec_maxima": 0,
        "stock_maximo": 0,
        "stock_actual": 1000,
        "posicion": 0,
        "obligatorio": false,
        "email_empresa_opcional": "",
        "oculto": false,
        "forzar_completo": false
    };
  }

  function addParticipantsToProduct(product) {
    if (currentPlan.value.id_promo == 0) {
      emit('planDetailsErrorHappened', "Debes guardar el plan antes de poder añadir participantes.");
    } else {
      selectedProductToAddParticipants.value = product;
    }
  }

  function editProduct(product) {
    selectedProduct.value = product;
  }

  function cloneProduct(product) {
    selectedProduct.value = { ...product };
    selectedProduct.value.id_producto_promo = -Math.floor(Math.random() * 10000) - 1;
  }

  function deleteProduct(product) {
    if (product.expirado) {
      emit('planDetailsErrorHappened', "No se puede mostrar un producto que ya ha caducado.");
      return;
    } else if (product.oculto) {
      twoButtonTitle.value = "Mostrar producto";
      twoButtonMessage.value = "¿Estás seguro de que quieres mostrar '" + product.titulo + "' en el plan?";
      twoButtonAcceptButton.value = "Si, mostrar";
    } else {
      twoButtonTitle.value = "Ocultar producto";
      twoButtonMessage.value = "¿Estás seguro de que quieres ocultar '" + product.titulo + "' del plan?";
      if (product.tiene_participantes) {
        twoButtonMessage.value += "\n\n🚨🚨Este producto tiene participantes.🚨🚨";
      }
      twoButtonAcceptButton.value = "Si, ocultar";
    }
    twoButtonCancelButton.value = "Cancelar";
    twoButtonConfirmed = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
      deleteProductConfirmed(product);
    };
    twoButtonCancelled = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
    }
  }

  function deleteProductConfirmed(product) {
    product.oculto = !product.oculto;
  }

  function addCustomPurchaseCodes() {
    addCustomPurchaseCodesPlanId.value = currentPlan.value.id_promo;
  }

  function secondaryCategoryChanged(category) {
    if (!currentPlan.value.otras_categorias.some(c => c.categoria === category.categoria && c.subcategoria === category.subcategoria)) {
      currentPlan.value.otras_categorias.push(category);
    }
  }

  function secondaryCategoryPopupCancelled() {
    selectedSecondaryCategory.value = null;
  }

  function secondaryCategoryErrorHappened(error) {
      emit('planDetailsErrorHappened', error);
  }

  </script>
  
  <style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    overflow-y: auto;
    overscroll-behavior: contain;
  }
  
  .bg-white {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    width: 90%;
    max-width: 1800px;
  }
  
  .popup {
    position: relative;
    width: 96%;
    max-width: 1800px;
    max-height: 90vh;
    overflow-y: hidden;
    border-radius: var(--radius-lg);
    padding: 0;
    box-shadow: var(--shadow-lg);
    display: flex;
    flex-direction: column;
  }

  .popup-scroll {
    overflow-y: auto;
    padding: var(--spacing-xl);
    flex: 1;
    position: relative;
  }

  .title {
    text-align: center;
    margin-top: 0;
    margin-bottom: var(--spacing-md);
    font-size: 24px;
    color: var(--text-color-dark);
  }

  .subtitle {
    text-align: center;
    margin-bottom: var(--spacing-md);
    color: var(--text-color-light);
  }

  .subtitle-codes {
    text-align: center;
    color: var(--clear-gray);
    margin-bottom: var(--spacing-md);
  }
  
  .subtitle-codes-mini {
    display: block;
    font-size: 12px;
    margin-top: 4px;
  }

  .close_icon {
    position: absolute;
    top: var(--spacing-md);
    right: var(--spacing-md);
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: transform var(--transition-fast);
  }

  .close_icon:hover {
    transform: scale(1.1);
  }

  h4 {
    margin-top: var(--spacing-lg);
    margin-bottom: var(--spacing-md);
    color: var(--primary-color);
    font-size: 18px;
    border-bottom: 2px solid var(--very-clear-gray);
    padding-bottom: 8px;
  }

  .fields {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-md);
  }

  /* Grid System using Flexbox and Gap */
  .input-25 { flex: 1 1 calc(25% - var(--spacing-md)); min-width: 200px; }
  .input-33 { flex: 1 1 calc(33.33% - var(--spacing-md)); min-width: 250px; }
  .input-50 { flex: 1 1 calc(50% - var(--spacing-md)); min-width: 300px; }
  .input-66 { flex: 1 1 calc(66.66% - var(--spacing-md)); min-width: 400px; }
  .input-100 { flex: 1 1 100%; }

  .gallery-input-33 {
    flex: 1 1 calc(33.33% - var(--spacing-md));
    position: relative;
  }

  label {
    display: block;
    margin-bottom: 6px;
    font-weight: 600;
    font-size: 14px;
    color: var(--text-color-dark);
  }

  input, select, textarea {
    width: 100%;
    box-sizing: border-box;
  }

  .input-checkbox {
    display: flex;
    align-items: center;
    height: 100%; /* Align with other inputs */
    padding-top: 28px; /* Align with inputs that have labels */
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    cursor: pointer;
    font-weight: normal;
  }

  .active_checkbox {
    width: 20px;
    margin: 0;
  }

  /* Quill Editor Overrides */
  ::v-deep(.ql-container) {
    font-family: "GatterSans" !important;
    font-size: 16px !important;
    border-bottom-left-radius: var(--radius-md);
    border-bottom-right-radius: var(--radius-md);
  }

  ::v-deep(.ql-toolbar) {
    border: 1px solid var(--light-gray) !important;
    border-top-left-radius: var(--radius-md);
    border-top-right-radius: var(--radius-md);
    background-color: var(--almost-white);
  }

  ::v-deep(.ql-editor) {
    border: 1px solid var(--light-gray) !important;
    border-top: 0px;
    min-height: 200px;
  }

  /* Images */
  .image-gallery {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    background-color: var(--almost-white);
    border-radius: var(--radius-md);
    border: 1px dashed var(--light-gray);
    cursor: pointer;
    transition: border-color var(--transition-fast);
  }

  .image-gallery:hover {
    border-color: var(--primary-color);
  }

  .image-gallery-delete {
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: white;
    border-radius: 50%;
    padding: 4px;
    box-shadow: var(--shadow-sm);
    cursor: pointer;
    width: 24px;
    height: 24px;
  }

  /* Buttons and Actions */
  .add_button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: var(--text-color-dark);
    font-weight: 600;
    cursor: pointer;
    transition: opacity var(--transition-fast);
    padding: 8px 0;
  }

  .add_button_small {
    font-size: 14px;
  }
    
  .add_button:hover {
    opacity: 0.8;
  }

  .action_icon {
    width: 20px;
    height: 20px;
  }

  .action_icon_small {
    width: 14px;
    height: 14px;
  }

  .campo-pedir-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 10px;
    opacity: 0.7;
    transition: opacity var(--transition-fast);
  }

  .campo-pedir-icon:hover {
    opacity: 1;
  }

  /* Tooltip */
  .tooltip-container {
    position: relative;
    cursor: help;
    border-bottom: 1px dotted var(--text-color-dark);
    display: inline-block;
  }

  .tooltip-text {
    visibility: hidden;
    width: 220px;
    background-color: var(--text-color-dark);
    color: white;
    text-align: center;
    border-radius: var(--radius-sm);
    padding: 8px;
    position: absolute;
    z-index: 100;
    bottom: 125%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.3s;
    font-size: 12px;
    font-weight: normal;
    box-shadow: var(--shadow-md);
  }

  .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--text-color-dark) transparent transparent transparent;
  }

  .tooltip-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
  }

  /* Transitions */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .fields {
      flex-direction: column;
      gap: 15px;
    }
    
    .input-25, .input-33, .input-50, .input-66 {
      flex: 1 1 100%;
      min-width: 0;
    }

    .popup {
      padding: var(--spacing-md);
      max-height: 100vh;
      border-radius: 0;
    }
  }
  </style>